"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithdrawalRequestsState = exports.WithdrawalRequestsStateData = void 0;
const program_1 = require("../program");
const buffer_1 = require("buffer");
const common_1 = require("@everlend/common");
class WithdrawalRequestsStateData extends common_1.Borsh.Data {
}
exports.WithdrawalRequestsStateData = WithdrawalRequestsStateData;
_a = WithdrawalRequestsStateData;
WithdrawalRequestsStateData.SCHEMA = _a.struct([
    ['accountType', 'u8'],
    ['accountVersion', 'u8'],
    ['pool', 'publicKey'],
    ['mint', 'publicKey'],
    ['liquiditySupply', 'u64'],
]);
class WithdrawalRequestsState extends common_1.Account {
    constructor(key, info) {
        super(key, info);
        if (!this.assertOwner(program_1.GeneralPoolsProgram.PUBKEY)) {
            throw common_1.Errors.ERROR_INVALID_OWNER();
        }
        this.data = WithdrawalRequestsStateData.deserialize(this.info.data);
    }
    static getPDA(poolMarket, tokenMint) {
        return program_1.GeneralPoolsProgram.findProgramAddress([
            buffer_1.Buffer.from(`withdrawals${WithdrawalRequestsState.VERSION}`),
            poolMarket.toBuffer(),
            tokenMint.toBuffer(),
        ]);
    }
}
exports.WithdrawalRequestsState = WithdrawalRequestsState;
WithdrawalRequestsState.LEN = 74;
WithdrawalRequestsState.VERSION = 'V0';
//# sourceMappingURL=withdrawalRequestsState.js.map